export const TITLES = {
  title: "Supermarktprijzen",
  slogan: "Betaal nooit meer teveel voor je boodschappen !",
  banner: "https://www.supermarktprijzen.be/img/banner.jpg",
  bannerAlt: "Supermarkt foto"
} 

export const SHOPS = {
    ah: {
        name: 'Albert Heijn',
        url: '/shop/ah',
        icon: '/img/ah.svg',
    },
    aldi: {
        name: 'Aldi',
        url: '/shop/aldi',
        icon: "/img/aldi.svg",
    },
    carrefour: {
        name: 'Carrefour',
        url: '/shop/carrefour',
        icon: "/img/carrefour.svg",
    },
    colruyt: {
        name: 'Colruyt',
        url: '/shop/colruyt',
        icon: "/img/colruyt.svg",
    },
    delhaize: {
        name: 'Delhaize',
        url: '/shop/delhaize',
        icon: "/img/delhaize.svg",
    }
};

// ,
//     bioplanet: {
//       name: 'Bioplanet',
//       url: '/shop/bioplanet',
//       icon: "/img/bioplanet.svg",
//   },
// export interface Tag {
//   tag: string;
//   description: string;
//   color: string;
// }

// export const TAGS: Tag[] = [{
//   "tag": "Niet-Voeding",
//   "description": "Producten die geen voedsel zijn",
//   "color": "#FF5733"
// }, {
//   "tag": "Brood En Granen",
//   "description": "Diverse soorten brood en granen",
//   "color": "#33FF57"
// }, {
//   "tag": "Vlees",
//   "description": "Verschillende soorten vleeswaren",
//   "color": "#3357FF"
// }, {
//   "tag": "Vis En Zeevruchten",
//   "description": "Verse en bevroren visproducten",
//   "color": "#FF33A6"
// }, {
//   "tag": "Melk, Kaas En Eieren",
//   "description": "Zuivelproducten en eieren",
//   "color": "#A633FF"
// }, {
//   "tag": "Oliën En Vetten",
//   "description": "Kookoliën en eetbare vetten",
//   "color": "#FF8C33"
// }, {
//   "tag": "Fruit",
//   "description": "Vers en bevroren fruit",
//   "color": "#33FFD1"
// }, {
//   "tag": "Groenten",
//   "description": "Verschillende soorten verse groenten",
//   "color": "#FF3333"
// }, {
//   "tag": "Suiker, Jam, Honing, Chocolade En Snoepgoed",
//   "description": "Zoetigheden en suikerproducten",
//   "color": "#8C33FF"
// }, {
//   "tag": "Sauzen En Kruiden",
//   "description": "Diverse soorten sauzen en kruiden",
//   "color": "#33FF8C"
// }, {
//   "tag": "Zout, Specerijen En Keukenkruiden",
//   "description": "Keukenzout en specerijen",
//   "color": "#FF33D1"
// }, {
//   "tag": "Voeding Voor Baby",
//   "description": "Speciaal voedsel voor baby’s",
//   "color": "#33A6FF"
// }, {
//   "tag": "Bereide Maaltijden",
//   "description": "Kant-en-klare maaltijden",
//   "color": "#FFD133"
// }, {
//   "tag": "Alcoholvrije Dranken",
//   "description": "Dranken zonder alcohol",
//   "color": "#D1FF33"
// }, {
//   "tag": "Alcoholische Dranken",
//   "description": "Bier, wijn en sterke dranken",
//   "color": "#33D1FF"
// }, {
//   "tag": "Huisdieren",
//   "description": "Voeding en producten voor huisdieren",
//   "color": "#A6FF33"
// }, {
//   "tag": "Diepvries",
//   "description": "Bevroren voedselproducten",
//   "color": "#FF5733"
// }, {
//   "tag": "Conserven",
//   "description": "Ingeblikte en gepreserveerde voedingsmiddelen",
//   "color": "#8CFF33"
// }, {
//   "tag": "Snacks En Tussendoortjes",
//   "description": "Kleine hapjes en tussendoortjes",
//   "color": "#5733FF"
// }, {
//   "tag": "Gezonde Voeding",
//   "description": "Voedingsmiddelen voor een gezond dieet",
//   "color": "#FF33FF"
// }, {
//   "tag": "Wereldkeuken",
//   "description": "Internationale gerechten en ingrediënten",
//   "color": "#33FF57"
// }, {
//   "tag": "Huishouden",
//   "description": "Producten voor huishoudelijk gebruik",
//   "color": "#FF8C33"
// }, {
//   "tag": "Lichaamsverzorging",
//   "description": "Verzorgingsproducten voor lichaamshygiëne",
//   "color": "#33FF33"
// }];
